import 'Styles/messages.scss';

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { pathToMessages, pathToMessagesFolder } from 'Utils/nav/NavHelpers';

import { resetMessages, fetchMessages } from 'Actions/MessagesviewActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { trackPageView, onPageView } from 'Actions/adsActions';
import { resetSelectedItem } from 'Actions/MetaActions';

import messagesSelector from 'Selectors/messagesSelector';

import PmFolder from 'Components/messages/FolderComponent';
import AdComponent from 'Components/ads/AdComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

class MessagesViewComponent extends React.Component {
	componentWillMount() {
		this.setState({
			pmroute: 'pmroot',
			id: null
		});
	}

	componentDidMount() {
		this.props.dispatch( resetSelectedItem() );
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetMessages() );
		this.props.dispatch( fetchMessages( {
			pmroute: 'pmroot',
			size: 1,
			page: 1,
			id: null
		} ) );
	}

	componentWillUnmount() {
		this.props.dispatch( resetSelectedItem() );
		this.props.dispatch( resetMessages() );
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	shouldComponentUpdate( nextProps ) {
		return (
			nextProps.messagesview.loaded !== this.props.messagesview.loaded ||
			nextProps.messagesview.isFetching !== this.props.messagesview.isFetching ||
			nextProps.messagesview.result.pmfolders.length !== this.props.messagesview.result.pmfolders.length
		);
	}

	goToFolder( folderId ) {
		if( isFinite( parseInt( folderId ) ) ) {
			this.props.dispatch(resetMessages());
			this.props.dispatch( push( pathToMessagesFolder( folderId ) ) );
		} else {
			this.props.dispatch(resetMessages());
			this.props.dispatch( push( pathToMessages() ) );
		}
	}

	render() {
		const { entities: { pmfolders }, result, loaded, isFetching } = this.props.messagesview;

		if( !loaded || isFetching ) {
			return <LoaderCss />;
		}

		let items_list = result.pmfolders.map(
			( k, i ) => {
				let className = "pmfolder " + ( pmfolders[ k ].unread > 0 ? 'unread' : '' );
				return (
					<li className={ className } key={`pmfolder_${i}`} onClick={ () => this.goToFolder( k ) } >
						<PmFolder key={ i } folder={ pmfolders[k] } />
					</li>
				);
			}
		),
		bottomAdUnit = <AdComponent adType="2" adName="Bottom_Content_Rectangle" />;

		return (
			<div className="messagesRoot">
				<ul>
					{ items_list  }
				</ul>
				{bottomAdUnit}
			</div>
		);
	}
}

export default connect( messagesSelector )( MessagesViewComponent );


// WEBPACK FOOTER //
// ./src/components/MessagesViewComponent.js